// src/pages/GRIDPage.jsx
import React from "react";
import LearnMoreLayout from "./components/ui/LearnMoreLayout"; // Adjust the import path as necessary

export default function GRIDPage() {
  const sections = [
    {
      id: "what-is-grid",
      title: "What GRID Bot is",
      navLabel: "What GRID Bot is",
      content: (
        <p className="text-[#585F72]">
          The Xenorize Grid Bot is a range-trading bot that aims to profit from
          price swings. It places multiple buy and sell levels so it can
          repeatedly buy lower and sell higher when the market moves up and
          down.
        </p>
      ),
    },
    {
      id: "how-it-trades",
      title: "How It Trades (High Level)",
      navLabel: "How It Trades (High Level)",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>
            Builds a ladder of buy levels below the market and sell levels above
            it.
          </li>
          <li>Buys when price dips into a lower level.</li>
          <li>Sells when price bounces into a higher level.</li>
          <li>
            Keeps the grid running so long as your configuration and capital
            allow.
          </li>
        </ul>
      ),
    },
    {
      id: "why-different",
      title: "Why It’s Different?",
      navLabel: "Why It’s Different",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>
            <span className="font-bold">Independent buy and sell spacing</span>{" "}
            – you can tune how often it buys vs how often it takes profit.
          </li>
          <li>
            <span className="font-bold">Simple, visible logic</span> – no hidden
            conditions, just a clear grid of levels.
          </li>
          <li>
            <span className="font-bold">Multiple profiles</span> – start with
            Conservative, Balanced, or Aggressive, then tweak as you gain
            experience.
          </li>
        </ul>
      ),
    },
    {
      id: "key-benefits",
      title: "Key Benefits for Users",
      navLabel: "Key Benefits for Users",
      content: (
        <ul className="list-disc pl-5 space-y-2 text-[#585F72]">
          <li>Turns sideways and choppy markets into a trading opportunity.</li>
          <li>
            Removes the need to watch the chart and manually place orders.
          </li>
          <li>
            Gives you a transparent structure for “buy low, sell high”
            behaviour.
          </li>
        </ul>
      ),
    },
  ];

  return (
    <LearnMoreLayout
      title="GRID"
      breadcrumb={[
        // NOTE: The layout component should handle prepending 'Home'.
        // We are following your structure here, but remember the previous conversation about duplicate 'Home' labels!
        { label: "Home", onClick: () => (window.location.href = "/") },
        { label: "GRID" },
      ]}
      sections={sections}
    />
  );
}
